<template>
  <div v-if="products.length > 0">
    <h2 class="store-headline mt-5">{{ componentHeadline }}</h2>

    <div class="related-products">
      <div v-for="product in products">
        <router-link 
          :to="{ name: 'product-detail', params: { productId: product.id }}" 
          class="product"
        >
          <img v-bind:src="product.image" alt="">
          <span class="product__name" v-html="product.name"></span>
          <span class="product__price">${{ product.price }} ea</span>
        </router-link>
      </div>

      <span class="product product--placeholder"></span>
      <span class="product product--placeholder"></span>
      <span class="product product--placeholder"></span>
      <span class="product product--placeholder"></span>
      <span class="product product--placeholder"></span>
      <span class="product product--placeholder"></span>
    </div> <!--  .related-products -->
  </div>
</template>

<script>
import store from '../store.js'

export default {
  props: ['product', 'headline', 'useCartProducts'],
  data() {
    return {
      max: 5,
    }
  },
  computed: {
    componentHeadline() {
      return this.headline || 'Related Products'
    },
    products() {
      let product = this.product

      if (this.product && this.product.categories) {
        let slugs = this.product.categories.map(category => {
          return category.slug
        })

        return store.getters.getProductsByCategorySlug(slugs, 6)
          .filter(p => {
            return p.id != product.id
          })

      } else {
        return store.getters.getRandomProducts(5)
      }
    }
  }
}
</script>
